// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ZNSk","image":"Header_image__8t3A_","name":"Header_name__r5QAo","info":"Header_info__vJgzL","infoRow":"Header_infoRow__2DtTR"};